// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f7f0;
  padding: 2rem;
}

.login-card {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 500px;
  overflow: hidden;
}

.login-header {
  background-color: #2c5530;
  color: white;
  padding: 2rem;
  text-align: center;
}

.login-header h1 {
  margin: 0;
  font-size: 2.5rem;
  font-weight: 600;
}

.login-header p {
  margin: 0.5rem 0 0;
  opacity: 0.9;
  font-size: 1.1rem;
}

.provider-select {
  padding: 2rem 2rem 1rem 2rem;
  text-align: center;
}

.provider-select h2 {
  color: #2c5530;
  margin-bottom: 1.5rem;
  font-size: 1.2rem;
}

.provider-buttons {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: center;
  margin-bottom: 1rem;
  margin-top: 1rem;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.provider-btn {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0.9rem 1.2rem;
  background: #f0f7f0;
  color: #2c5530;
  border: 2px solid #e8f3e8;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, border 0.2s, color 0.2s;
  margin: 0 0.25rem;
}

.provider-btn:hover, .provider-btn.active {
  background: #4caf50;
  color: #fff;
  border-color: #4caf50;
}

.provider-icon {
  font-size: 1.3rem;
}

.login-content {
  padding: 2rem;
}

.back-btn {
  background: none;
  border: none;
  color: #4a6b4d;
  font-size: 1rem;
  margin-bottom: 1.5rem;
  cursor: pointer;
  text-align: left;
  padding: 0;
  transition: color 0.2s;
}

.back-btn:hover {
  color: #2c5530;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.login-form input {
  padding: 0.9rem 1rem;
  border: 1.5px solid #e8f3e8;
  border-radius: 6px;
  font-size: 1rem;
  color: #2c5530;
  background: #f8f9fa;
  outline: none;
  transition: border 0.2s;
}

.login-form input:focus {
  border-color: #4caf50;
  background: #fff;
}

.login-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 1rem;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  margin-top: 0.5rem;
}

.login-button:disabled {
  background-color: #b2dfb2;
  cursor: not-allowed;
}

.login-button:hover:not(:disabled) {
  background-color: #43a047;
}

.button-icon {
  margin-right: 0.5rem;
  font-size: 1.2rem;
}

.login-toggle {
  text-align: center;
  margin-top: 0.5rem;
}

.login-toggle button {
  background: none;
  border: none;
  color: #4caf50;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  margin-left: 0.25rem;
  transition: color 0.2s;
}

.login-toggle button:hover {
  color: #2c5530;
}

.error-message {
  color: #d32f2f;
  font-size: 0.95rem;
  margin-top: -0.5rem;
  margin-bottom: 0.5rem;
  text-align: left;
}

.welcome-card {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  text-align: center;
  max-width: 400px;
}

.user-avatar {
  width: 100px;
  height: 100px;
  margin: 0 auto 1.5rem;
}

.user-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.avatar-placeholder {
  width: 100%;
  height: 100%;
  background-color: #4caf50;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  font-weight: 600;
}

.welcome-card h1 {
  color: #2c5530;
  margin: 0 0 0.5rem;
}

.welcome-card p {
  color: #4a6b4d;
  margin: 0;
}

#recaptcha-container {
  margin: 1rem 0;
  display: flex;
  justify-content: center;
}

@media (max-width: 500px) {
  .login-card {
    padding: 0.5rem;
    max-width: 100vw;
  }
  .login-header {
    padding: 1rem;
  }
  .login-content {
    padding: 1rem;
  }
  .provider-select {
    padding: 1rem 1rem 0.5rem 1rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,SAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oDAAoD;EACpD,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".login-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f0f7f0;\n  padding: 2rem;\n}\n\n.login-card {\n  background-color: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 500px;\n  overflow: hidden;\n}\n\n.login-header {\n  background-color: #2c5530;\n  color: white;\n  padding: 2rem;\n  text-align: center;\n}\n\n.login-header h1 {\n  margin: 0;\n  font-size: 2.5rem;\n  font-weight: 600;\n}\n\n.login-header p {\n  margin: 0.5rem 0 0;\n  opacity: 0.9;\n  font-size: 1.1rem;\n}\n\n.provider-select {\n  padding: 2rem 2rem 1rem 2rem;\n  text-align: center;\n}\n\n.provider-select h2 {\n  color: #2c5530;\n  margin-bottom: 1.5rem;\n  font-size: 1.2rem;\n}\n\n.provider-buttons {\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n  justify-content: center;\n  margin-bottom: 1rem;\n  margin-top: 1rem;\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n}\n\n.provider-btn {\n  flex: 1 1 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  padding: 0.9rem 1.2rem;\n  background: #f0f7f0;\n  color: #2c5530;\n  border: 2px solid #e8f3e8;\n  border-radius: 8px;\n  font-size: 1.1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.2s, border 0.2s, color 0.2s;\n  margin: 0 0.25rem;\n}\n\n.provider-btn:hover, .provider-btn.active {\n  background: #4caf50;\n  color: #fff;\n  border-color: #4caf50;\n}\n\n.provider-icon {\n  font-size: 1.3rem;\n}\n\n.login-content {\n  padding: 2rem;\n}\n\n.back-btn {\n  background: none;\n  border: none;\n  color: #4a6b4d;\n  font-size: 1rem;\n  margin-bottom: 1.5rem;\n  cursor: pointer;\n  text-align: left;\n  padding: 0;\n  transition: color 0.2s;\n}\n\n.back-btn:hover {\n  color: #2c5530;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.login-form input {\n  padding: 0.9rem 1rem;\n  border: 1.5px solid #e8f3e8;\n  border-radius: 6px;\n  font-size: 1rem;\n  color: #2c5530;\n  background: #f8f9fa;\n  outline: none;\n  transition: border 0.2s;\n}\n\n.login-form input:focus {\n  border-color: #4caf50;\n  background: #fff;\n}\n\n.login-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 1rem;\n  background-color: #4caf50;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1.1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n  margin-top: 0.5rem;\n}\n\n.login-button:disabled {\n  background-color: #b2dfb2;\n  cursor: not-allowed;\n}\n\n.login-button:hover:not(:disabled) {\n  background-color: #43a047;\n}\n\n.button-icon {\n  margin-right: 0.5rem;\n  font-size: 1.2rem;\n}\n\n.login-toggle {\n  text-align: center;\n  margin-top: 0.5rem;\n}\n\n.login-toggle button {\n  background: none;\n  border: none;\n  color: #4caf50;\n  font-weight: 500;\n  cursor: pointer;\n  padding: 0;\n  margin-left: 0.25rem;\n  transition: color 0.2s;\n}\n\n.login-toggle button:hover {\n  color: #2c5530;\n}\n\n.error-message {\n  color: #d32f2f;\n  font-size: 0.95rem;\n  margin-top: -0.5rem;\n  margin-bottom: 0.5rem;\n  text-align: left;\n}\n\n.welcome-card {\n  background-color: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  padding: 2rem;\n  text-align: center;\n  max-width: 400px;\n}\n\n.user-avatar {\n  width: 100px;\n  height: 100px;\n  margin: 0 auto 1.5rem;\n}\n\n.user-avatar img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.avatar-placeholder {\n  width: 100%;\n  height: 100%;\n  background-color: #4caf50;\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 2.5rem;\n  font-weight: 600;\n}\n\n.welcome-card h1 {\n  color: #2c5530;\n  margin: 0 0 0.5rem;\n}\n\n.welcome-card p {\n  color: #4a6b4d;\n  margin: 0;\n}\n\n#recaptcha-container {\n  margin: 1rem 0;\n  display: flex;\n  justify-content: center;\n}\n\n@media (max-width: 500px) {\n  .login-card {\n    padding: 0.5rem;\n    max-width: 100vw;\n  }\n  .login-header {\n    padding: 1rem;\n  }\n  .login-content {\n    padding: 1rem;\n  }\n  .provider-select {\n    padding: 1rem 1rem 0.5rem 1rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
